import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card"

interface PreviewNotFoundProps {
  onNavigateToList: () => void
}

export function PreviewNotFound({ onNavigateToList }: PreviewNotFoundProps) {
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>Preview Not Found</CardTitle>
        <CardDescription>The requested preview could not be found or has been removed.</CardDescription>
      </CardHeader>
      <CardContent>
        <p>Please check the preview ID and try again, or return to the previews list.</p>
      </CardContent>
      <CardFooter>
        <Button onClick={onNavigateToList}>Go to Previews</Button>
      </CardFooter>
    </Card>
  )
}
